<template>
  <section class="safe-insets grid min-h-screen place-items-center bg-hazel-50 py-4 pt-11">
    <div class="mx-auto w-full max-w-[27rem] space-y-6 overflow-hidden rounded-lg bg-white p-8">
      <div>
        <img src="@/assets/carvia_logo.svg" alt="Logo" class="mx-auto mb-8 w-64 max-w-full" />
        <h1 class="text-center font-medium">
          {{ t('resetPassword') }}
        </h1>
      </div>
      <form class="grid gap-4" @submit="onPasswordReset">
        <InputField
          name="password"
          autocomplete="new-password"
          :label="t('password')"
          type="password"
        />

        <InputField
          autocomplete="new-password"
          name="passwordConfirm"
          :label="t('passwordConfirm')"
          type="password"
        />
        <CVButton type="submit" :is-loading="isPending" variant="default">
          {{ t('save') }}
        </CVButton>
      </form>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useResetPassword } from '@/queries/auth/use-password-reset';
import { resetPasswordSchema } from '@/validation/reset-password.schema';
import { useForm } from 'vee-validate';
import { useRoute } from 'vue-router';
import InputField from '@/components/InputField.vue';
import router from '@/router';

interface FormValues {
  passwordConfirm: string;
  password: string;
}
const route = useRoute();
const { token } = route.query;
const { t } = useI18n();
const { mutateAsync: resetPassword, isPending } = useResetPassword();

const { handleSubmit, resetForm } = useForm<FormValues>({
  validationSchema: resetPasswordSchema,
});

const onPasswordReset = handleSubmit(async (values) => {
  await resetPassword({
    password: values.password,
    token: token as string,
  });
  resetForm();
  await router.push({ name: 'home' });
});
</script>

<i18n lang="json">
{
  "en": {
    "resetPassword": "Reset Password",
    "password": "Password",
    "save": "Save",
    "passwordConfirm": "Confirm Password"
  },
  "de": {
    "resetPassword": "Passwort zurücksetzen",
    "password": "Passwort",
    "save": "Speichern",
    "passwordConfirm": "Passwort bestätigen"
  },
  "es": {
    "resetPassword": "Restablecer contraseña",
    "password": "Contraseña",
    "save": "Guardar",
    "passwordConfirm": "Confirmar contraseña"
  }
}
</i18n>
